import { getProviderWithLifeInsurancePlans } from '@/graphql/queries/shared/institution';
import lang from '@/lang/middleware/products/protection/life-insurance';

export default async ({ $apolloQuery, route, store }) => {
  store.$i18n.mergeLocaleMessage('en', lang.en);
  const coverType = store.getters['products/getCoverType'];
  await $apolloQuery(getProviderWithLifeInsurancePlans, { product: coverType.api, slug: route.params.provider }).then(provider => {
    const description = provider.description;
    const title = store.$i18n.t('provider.title', { coverType: coverType.name, provider: provider.name });
    store.commit('blog/setArticles', provider.articles);
    store.commit('jumbotron/SET_JUMBOTRON', { subtitle: description, title, type: 'generic' });
    store.commit('pageContent/SET_DYNAMIC_BREADCRUMBS', [
      ['i18n/home', '/'], ['i18n/insurance', '/insurance/'], [`i18n/${coverType.scope}`, `/${coverType.path}/`],
      ['i18n/providers', `/${coverType.path}/providers/`], provider.name
    ]);
    store.commit('pageContent/setHead', { description, title });
    store.commit('products/setCoverType', coverType);
    store.commit('products/setList', provider.life_insurance_plans);
    delete provider.articles;
    delete provider.plans;
    store.commit('providers/set', provider);
  }).catch(e => {
    console.error(e);
  });
};
